//import React, {ChangeEvent, useState, useEffect} from "react";
import React, {useState, useEffect} from "react";
import LinkList from "./linklist";
import './quickacces.scss';
import StickyNoteList from './stickynotelist';
interface Props {
    fnGetNotes;
    fnSaveNotes;
    fnGetLinks;
    fnSaveLinks;
    CacheNotes;
    CacheLinks;
    Notes;
    Links;
    culture;
    fnGetPrev;
}

const QuickViewTabs: React.FC<Props> = (props) => {
    let viewsticky='stickynote';
    let viewlinks='mylinks';
    const [view, setview] = useState<string>(viewsticky);
    useEffect(() => {
        return () => {
        }
    }, []);

    useEffect(() => {
    });

    useEffect(() => {
    }, [view]);
    
    return (
        <div className="quickaccess">
            <div  className="tabcontainer">
                <div className="tabactioncontainer">
                    <span style={{marginRight:'20px'}}  onClick={()=>{
                            if(view!=viewsticky){
                                setview(viewsticky);
                            }
                        }} className={view==viewsticky?"mipatab mipatabactive":"mipatab"}>Sticky Note</span>
                    <span style={{marginRight:'20px'}}  onClick={()=>{
                        if(view!=viewlinks){
                            setview(viewlinks);
                        }
                    }} className={view==viewlinks?"mipatab mipatabactive":"mipatab"}>Links</span>
                </div>
                        
                    <div className={view==viewsticky?"mipatabbox mipatabboxactive":"mipatabbox"}>
                       <StickyNoteList fnGetNotes={props.fnGetNotes} fnUpdateNote={props.fnSaveNotes} 
                       CacheNote={props.CacheNotes} NoteList={props.Notes}
                       culture={props.culture}
                       key={1}></StickyNoteList>
                    </div>
                    <div className={view==viewlinks?"mipatabbox mipatabboxactive":"mipatabbox"}>
                       <LinkList fnGetLinks={props.fnGetLinks} fnUpdateLink={props.fnSaveLinks} 
                       CacheLinks={props.CacheLinks}  AllLinks={props.Links} Culture={props.culture}
                       fnGetPrev={props.fnGetPrev}
                       ></LinkList>
                    </div>
            </div>
        </div>
    )
};

export default QuickViewTabs;